import { useEffect, useState } from 'react';

function parseParts(value: string): { hour: string; minute: string } {
  if (!value) return { hour: '', minute: '' };
  const [h, m] = value.split(':');
  const hi = parseInt(h, 10);
  const mi = parseInt(m, 10);
  if (isNaN(hi) || isNaN(mi)) return { hour: '', minute: '' };
  return { hour: String(hi), minute: String(mi).padStart(2, '0') };
}

const HOURS   = Array.from({ length: 24 }, (_, i) => i);           // 0–23
const MINUTES = Array.from({ length: 60 }, (_, i) => i);           // 0–59

interface Props {
  value: string;                    // "HH:MM" or ""
  onChange: (value: string) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export function BirthTimeInput({ value, onChange, disabled, style }: Props) {
  const parts = parseParts(value);
  const [hour,   setHour]   = useState(parts.hour);
  const [minute, setMinute] = useState(parts.minute);

  useEffect(() => {
    const p = parseParts(value);
    setHour(p.hour);
    setMinute(p.minute);
  }, [value]);

  function emit(h: string, m: string) {
    if (h === '' || m === '') { onChange(''); return; }
    const hh = String(parseInt(h, 10)).padStart(2, '0');
    const mm = String(parseInt(m, 10)).padStart(2, '0');
    onChange(`${hh}:${mm}`);
  }

  function handleHour(h: string) {
    setHour(h);
    emit(h, minute);
  }

  function handleMinute(m: string) {
    setMinute(m);
    emit(hour, m);
  }

  const selectStyle: React.CSSProperties = {
    flex: 1,
    padding: '0.35rem 0.25rem',
    fontSize: 'var(--text-body)',
    opacity: disabled ? 0.45 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
  };

  return (
    <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center', ...style }}>
      <select
        value={hour}
        onChange={e => handleHour(e.target.value)}
        disabled={disabled}
        className="form-input"
        aria-label="Hora"
        style={{ ...selectStyle, width: '5rem', flexGrow: 0 }}
      >
        <option value="">Hora</option>
        {HOURS.map(h => (
          <option key={h} value={h}>{String(h).padStart(2, '0')}</option>
        ))}
      </select>

      <span style={{ color: 'var(--text-muted)', fontWeight: 600, flexShrink: 0 }}>:</span>

      <select
        value={minute}
        onChange={e => handleMinute(e.target.value)}
        disabled={disabled}
        className="form-input"
        aria-label="Minuto"
        style={{ ...selectStyle, width: '5rem', flexGrow: 0 }}
      >
        <option value="">Min</option>
        {MINUTES.map(m => (
          <option key={m} value={String(m).padStart(2, '0')}>{String(m).padStart(2, '0')}</option>
        ))}
      </select>
    </div>
  );
}
